import { render, staticRenderFns } from "./ZoneGenderRatePie.vue?vue&type=template&id=6bfc46bd&"
import script from "./ZoneGenderRatePie.vue?vue&type=script&lang=ts&"
export * from "./ZoneGenderRatePie.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneGenderRatePie.vue?vue&type=style&index=0&id=6bfc46bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ZoneGenderRatePie.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./ZoneGenderRatePie.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QBtn,QMenu,QList,QItem,QItemSection,QBtnToggle,QCardSection,QBtnGroup,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtn,QMenu,QList,QItem,QItemSection,QBtnToggle,QCardSection,QBtnGroup})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
